import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from './auto-image'

const Outer = styled.div`
  margin-top: 2rem;
  @media (max-width: 40rem){
    margin-top: 0;
  }
`

const Item = styled.div`
  background-color: #fff;
  padding: 3rem 4rem;
  @media (max-width: 40rem){
    margin: 0 -1rem;
    padding: 2rem 1rem;
  }
  & + & {
    margin-top: 2rem;
    @media (max-width: 40rem){
      margin-top: 1rem;
    }
  }
`

const Title = styled.div`
  font-size: 1.5rem;
  color: #96607a;
  margin-bottom: 2rem;
`

const Inner = styled.div`

  display: grid;
  grid-template-columns: fit-content(100%) 1fr;
  gap: 2rem;
  @media (max-width: 40rem){
    grid-template-columns: 1fr;
    gap: 0;
  }
`

const Label = styled.div`
  font-weight: 700;
  line-height: 1.75;
`

const Value = styled.div`
  line-height: 1.75;
  margin-bottom: 2rem;
`

const ImageContainer = styled.div`
  margin-top: 3rem;
  @media (max-width: 40rem){
    margin: 1rem -1rem 0;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

type SaiyouSectionProps = {

}
export const SaiyouSection: FunctionComponent<SaiyouSectionProps> = () => {
  return <Outer>
    <Item>
      <Title>
        採用条件
      </Title>
      <Inner>
        <Label>募集人数</Label>
        <Value>5〜6名程度</Value>
        <Label>職種</Label>
        <Value>保育教諭（幼稚園教諭免許状および保育士資格取得者）<br />1年目は原則として副担任あるいはフリー</Value>
        <Label>雇用形態</Label>
        <Value>常勤者</Value>
        <Label>勤務地</Label>
        <Value>横浜市港南区</Value>
        <Label>勤務時間</Label>
        <Value>午前７時30分～午後６時30分のうち<br />9時間拘束8時間勤務</Value>
        <Label>休日</Label>
        <Value>土・日曜、祝日<br />※夏休み、年末年始休暇あり<br />※土曜日は月１回出勤日</Value>
        <Label>福利厚生</Label>
        <Value>健康保険（私学共済）、労災、雇用保険、退職金制度、家賃補助制度あり</Value>
        <Label>研修制度</Label>
        <Value>保育技術向上研修、ビジネスマナー研修など</Value>
        <Label>仕事内容</Label>
        <Value>0歳～6歳までの乳幼児への保育活動、教育カリキュラムの作成、活動のための準備、行事の企画や進行、職員会議、書類作成、保護者対応、送迎バスの添乗業務、掃除など</Value>
        <Label>応募制限</Label>
        <Value>特に制限なし</Value>
        <Label>受動喫煙措置の記載</Label>
        <Value>敷地内禁煙</Value>
      </Inner>
    </Item>
    <Item>
      <Title>
        採用試験要項
      </Title>
      <Inner>
        <Label>提出書類</Label>
        <Value>❶履歴書：1通　❷成績証明書：1通　❸卒業見込証明書：1通　❹資格取得見込証明書：1通 ❺健康診断書：1通（採用試験日に持参）</Value>
        <Label>試験内容</Label>
        <Value>❶簡単な面接シート（お人柄を知るためのものです）<br />❷面接 ※ピアノや保育などの実技試験はございません</Value>
        <Label>応募方法</Label>
        <Value>まずは園見学にお越しください。<br />その上で、試験日を決めさせていただきます。</Value>
      </Inner>
    </Item>
    <ImageContainer>
      <AutoImage src='/images/req_img_06.png' mobileSrc='/images/req_img_06_mobile.png' />
    </ImageContainer>
  </Outer>
}